import React from 'react';

import { MapTo, Utils } from '@adobe/aem-react-editable-components';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { CardComponent } from 'components/CardComponent';
import { RenderAemComponent } from 'components/RenderAemComponent/RenderAemComponent';

import { sortMetaNav } from 'utils/CardDataUtils';

import './ExpertSearch.sass';

const CardCollection = (props) => {
  const { metaNav } = props;
  const isEditor = Utils.isInEditor();

  if (isEditor) {
    return <RenderAemComponent componentProps={props} name="CardCollection" />;
  }
  if (!metaNav) {
    return <div>Keine Links vorhanden.</div>;
  }

  const parsedCards = sortMetaNav(metaNav.links);

  return (
    <div className="expert-page-content-sites">
      <div className="mdl-grid search-pre-section-card-grid">
        {parsedCards.map((card, index) => (
          <Link key={index} to={card.linkedPage}>
            <CardComponent
              cardClass="search-pre-selection-card mdl-cell mdl-cell--4-col"
              card={card}
            />
          </Link>
        ))}
      </div>
    </div>
  );
};
CardCollection.propTypes = {
  metaNav: PropTypes.object.isRequired,
};
MapTo('e-fix/components/content/cardcollection')(CardCollection);
